

import React from "react";
import {
    Box,
    Button,
    TextField,
    IconButton,
    Typography,
    Paper,
    Grid,
    MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { ViewContext } from "components/lib";
import { useContext } from "react";

export function References({ references, setReferences }) {
    const viewContext = useContext(ViewContext);

    const handleAddReference = () => {
        const newReference = {
            author: "",
            title: "",
            year: "",
            sourceType: "",
            publisher: "",
            url: ""
        };
        setReferences([newReference, ...references]);
    };

    const handleRemoveReference = (index) => {
        const updated = references.filter((_, i) => i !== index);
        setReferences(updated);
    };

    const handleChange = (index, field, value) => {
        const updated = [...references];
        updated[index][field] = value;
        setReferences(updated);
    };

    return (
        <Box sx={{ width: "100%", p: 3 }}>
            <Button
                variant="contained"
                startIcon={<AddIcon />}
                fullWidth
                sx={{
                    backgroundColor: "#1450a0",
                    borderRadius: "10px",
                    py: 1.5,
                    textTransform: "none",
                    fontSize: "16px",
                    "&:hover": { backgroundColor: "#165bb6" }
                }}
                onClick={handleAddReference}
            >
                {viewContext.t('Components.Reference.body.add')}
            </Button>

            <Typography variant="body2" sx={{ mt: 1.5, color: "gray", textAlign: "center" }}>
                {viewContext.t('Components.Reference.body.desc')}
            </Typography>

            <Box sx={{ mt: 3 }}>
                {references.map((ref, index) => (
                    <Paper key={index} sx={{ p: 2, mb: 2, border: "1px solid #e0e0e0", borderRadius: "8px" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label={viewContext.t('Components.Reference.title.author')}
                                    value={ref.author}
                                    onChange={(e) => handleChange(index, "author", e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label={viewContext.t('Components.Reference.title.title')}
                                    value={ref.title}
                                    onChange={(e) => handleChange(index, "title", e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label={viewContext.t('Components.Reference.title.publicationYear')}
                                    value={ref.year}
                                    onChange={(e) => handleChange(index, "year", e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label={viewContext.t('Components.Reference.title.sourceType')}
                                    value={ref.sourceType}
                                    onChange={(e) => handleChange(index, "sourceType", e.target.value)}
                                >
                                    <MenuItem value="Book">Book</MenuItem>
                                    <MenuItem value="Journal">Journal</MenuItem>
                                    <MenuItem value="Conference">Conference</MenuItem>
                                    <MenuItem value="Website">Website</MenuItem>
                                    <MenuItem value="Thesis">Thesis</MenuItem>
                                    <MenuItem value="Report">Report</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label={viewContext.t('Components.Reference.title.publisher')}
                                    value={ref.publisher}
                                    onChange={(e) => handleChange(index, "publisher", e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label={viewContext.t('Components.Reference.title.url')}
                                    value={ref.url}
                                    onChange={(e) => handleChange(index, "url", e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{ textAlign: "right" }}>
                                <IconButton color="error" onClick={() => handleRemoveReference(index)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Paper>
                ))}
            </Box>
        </Box>
    );
}